import { SET_GROUPS } from "../actions/groupsActions";


const defaultState = {
    groups: []
}

export const groupsReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_GROUPS) return { ...state, groups: data };
    return state;
}